var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import auth from '../../../../../base/auth';
import { vote } from '../../../utils/api';
const formatTime = (time, date) => {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    const year = month * 12;
    const now = new Date().getTime();
    const diffValue = now - time;
    if (diffValue < 0) {
        return '';
    }
    const yearC = diffValue / year;
    const monthC = diffValue / month;
    const weekC = diffValue / (7 * day);
    const dayC = diffValue / day;
    const hourC = diffValue / hour;
    const minC = diffValue / minute;
    let result = '';
    if (yearC > 3) {
        result = date;
    }
    else if (yearC > 1) {
        result = `${parseInt(yearC.toString())}年前`;
    }
    else if (monthC >= 1) {
        result = `${parseInt(monthC.toString())}月前`;
    }
    else if (weekC >= 1) {
        result = `${parseInt(weekC.toString())}周前`;
    }
    else if (dayC >= 1) {
        result = `${parseInt(dayC.toString())}天前`;
    }
    else if (hourC >= 1) {
        result = `${parseInt(hourC.toString())}小时前`;
    }
    else if (minC >= 1) {
        result = `${parseInt(minC.toString())}分钟前`;
    }
    else {
        result = '刚刚';
    }
    return result;
};
// @flow
class HotListItem extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            uptimes: this.props.content.uptimes ? this.props.content.uptimes : 0,
            hasZan: false,
        };
        // 推荐评论内容或者回复的内容
        this.handleRecommend = (e) => __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            let { uptimes } = this.state;
            const { voteData: { cmtVoteUrl, docUrl }, content: { comment_id }, } = this.props;
            try {
                if (auth.isLogin()) {
                    const data = yield vote(cmtVoteUrl, comment_id, docUrl);
                    if (data.code === 1) {
                        uptimes += 1;
                        this.setState({ uptimes, hasZan: true });
                    }
                }
                else {
                    window.alert('登录之后才能推荐哦，请先登录');
                    window.location.href = `//user.ifeng.com/login?cb=${location.href}`;
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    render() {
        const { uptimes, hasZan } = this.state;
        const { content, commentUrl } = this.props;
        const date = `${content.year}-${content.date}-${content.time}`;
        const time = new Date(date).getTime();
        console.log(content, '222222');
        return (React.createElement("div", { className: styles.hotItem },
            React.createElement("div", { className: styles.caption },
                React.createElement("img", { src: content.faceurl }),
                React.createElement("div", { className: styles.info },
                    React.createElement("div", { className: styles.username },
                        React.createElement("a", { href: `//gentie.ifeng.com/myComments?guid=${content.user_id}` }, content.uname),
                        React.createElement("div", { className: styles.voteNum, onClick: this.handleRecommend },
                            React.createElement("a", null, uptimes),
                            hasZan ? React.createElement("span", { className: styles.zand }) : React.createElement("span", { className: styles.zan }))),
                    React.createElement("p", { className: styles.txt },
                        React.createElement("a", { href: commentUrl },
                            React.createElement("span", { className: styles.contentTxt, dangerouslySetInnerHTML: { __html: content.contents || '' } }))),
                    React.createElement("span", { className: styles.commentTime },
                        (content === null || content === void 0 ? void 0 : content.ip_from) ? `${content === null || content === void 0 ? void 0 : content.ip_from} ` : '',
                        formatTime(time, date))))));
    }
}
export default HotListItem;
